const symbol = (currency, country, skipLongSymbol = false) => {
  if (skipLongSymbol) {
    return {
      eur: "€",
      usd: "$",
      gbp: "£",
      krw: "₩",
      cny: "¥",
      jpy: "¥",
      aud: "$",
    }[currency.toLowerCase()];
  }

  if (country === "US" && currency.toLowerCase() === "usd") {
    return "$";
  }

  return {
    eur: "€",
    usd: "US $",
    gbp: "£",
    krw: "₩",
    cny: "¥",
    jpy: "¥",
    aud: "AU $",
  }[currency.toLowerCase()];
};

const all = ["eur", "usd", "gbp", "krw", "cny", "jpy", "aud"];
const allInZuora = ["eur", "usd", "gbp", "krw", "jpy", "aud"];

const extractPrice = (prices, currency) =>
  prices[currency.toLowerCase()] || prices[currency.toUpperCase()];

const COMMA_CURRENCIES = ["jpy", "usd"];

const prettyPrint = (value, currency, country, skipLongSymbol = false) => {
  const [whole, dec] = Number(value).toFixed(2).split(".");

  const separator = COMMA_CURRENCIES.includes(currency.toLowerCase())
    ? ","
    : " ";

  if (whole.length > 3) {
    const remainder = whole.length % 3;

    return [
      symbol(currency, country, skipLongSymbol),
      remainder !== 0 ? `${whole.slice(0, remainder) + separator}` : "",
      whole.slice(remainder).match(/\d{3}/g).join(separator),
      dec && dec !== "00" ? "." : "",
      dec && dec !== "00" ? dec : "",
    ].join("");
  } else {
    return [
      symbol(currency, country, skipLongSymbol),
      whole,
      dec && dec !== "00" ? "." : "",
      dec && dec !== "00" ? dec : "",
    ].join("");
  }
};

const split = (value) => Number(value).toFixed(2).split(".");

const shouldSkipCents = (currency) =>
  ["krw", "jpy", "cny"].includes(currency.toLowerCase());

export default {
  all,
  allInZuora,
  symbol,
  extractPrice,
  prettyPrint,
  split,
  shouldSkipCents,
};
